import { IAffectedWallet } from '@entities/wallets';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

interface LimitsIssueDialogProps {
  open: boolean;
  affectedWallets: IAffectedWallet[];
  onCancel: () => void;
  onConfirm: () => void;
  confirmLoading?: boolean;
}

export const LimitsIssueDialog = ({
  open,
  affectedWallets,
  onCancel,
  onConfirm,
  confirmLoading,
}: LimitsIssueDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth='sm' fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          gap: 1,
        }}
      >
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            bgcolor: 'primary.main',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 700,
            fontSize: 32,
          }}
        >
          !
        </Box>
        Limits issue
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
        <Typography variant='body1' textAlign='center'>
          Updating the status of this wallet will remove its ability to receive deposits for the
          amounts:
        </Typography>

        <Stack spacing={1.5}>
          {affectedWallets.map(wallet => (
            <Box
              key={`${wallet.mid_name}-${wallet.min_amount}-${wallet.max_amount}`}
              sx={{
                display: 'flex',
                gap: 1,
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant='body1' fontWeight={600}>
                {wallet.mid_name}
              </Typography>
              <Typography variant='body1' color='error' fontWeight={700}>
                {wallet.min_amount} - {wallet.max_amount}
              </Typography>
            </Box>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant='outlined' onClick={onCancel}>
          Cancel
        </Button>
        <Button variant='contained' onClick={onConfirm} disabled={confirmLoading}>
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};
